const TONES = {
  gray: { bg: 'bg-gray-50', icon: 'text-gray-500', ring: 'ring-gray-100' },
  blue: { bg: 'bg-blue-50', icon: 'text-blue-600', ring: 'ring-blue-100' },
  green: { bg: 'bg-emerald-50', icon: 'text-emerald-600', ring: 'ring-emerald-100' },
  violet: { bg: 'bg-violet-50', icon: 'text-violet-600', ring: 'ring-violet-100' },
  amber: { bg: 'bg-amber-50', icon: 'text-amber-600', ring: 'ring-amber-100' },
};

export default function KpiCard({ label, value, accent = 'text-gray-800', tone = 'gray', icon }) {
  const t = TONES[tone] || TONES.gray;
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow flex items-center gap-3">
      {icon && (
        <div className={`shrink-0 w-10 h-10 rounded-lg ${t.bg} ${t.icon} ring-1 ${t.ring} flex items-center justify-center`}>
          {icon}
        </div>
      )}
      <div className="min-w-0">
        <div className="text-xs font-medium text-gray-500 mb-0.5 truncate">{label}</div>
        <div className={`text-2xl font-semibold tracking-tight ${accent}`}>{value}</div>
      </div>
    </div>
  );
}
